export default {
  getScopeOperationLogs: {
    server: '/operation-logs/scope',
    method: 'get',
  },
  getUserOperationLogs: {
    server: '/operation-logs/user',
    method: 'get',
  },
  query: {
    server: '/operation-logs/query',
    method: 'get',
  },
};
